import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Icon from '../../Common/Icon';
import Button from '../../Common/Button';
import { enableCard } from '../../../store/cards';
import communicationBridge from '../../../functions/communicationBridge';
import { COMPANION_APP_URL } from '../../../constants/appLinks';

function CompanionAppSwitchConfirmation() {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const closeCard = () => {
        dispatch(enableCard(false));
    };

    const confirmSwitch = () => {
        dispatch(enableCard(false));
        if (communicationBridge.isBridgeMode()) {
            communicationBridge.switchApp();
            return;
        }
        window.location.assign(COMPANION_APP_URL);
    };

    return (
        <div className="card">
            <div className="close-card">
                <span className="close" onClick={closeCard}>
                    &times;
                </span>
            </div>
            <div className="confirmation-wrapper">
                <Icon cssClass={'warning-icon'} iconName={'external-link-alt'} iconColor={'#5236ab'}></Icon>
                <p className="success-text header">
                    {t('dashboard.companionAppSwitchConfirmation.header')}
                </p>
                <p className="info">
                    {t('dashboard.companionAppSwitchConfirmation.info')}
                </p>
                <div className="buttons-wrapper">
                    <Button
                        variant={'primary'}
                        height={'regular'}
                        width={'full'}
                        clickHandler={confirmSwitch}
                        translationKey={'dashboard.companionAppSwitchConfirmation.confirm'}
                    />
                    <Button
                        cssClass={'close-button'}
                        variant={'tertiary'}
                        height={'regular'}
                        width={'full'}
                        clickHandler={closeCard}
                        translationKey={'common.cancelButton'}
                    />
                </div>
            </div>
        </div>
    );
}

export default CompanionAppSwitchConfirmation;
